var React = require('react');

function YoutubeIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 1.5H38C42.6954 1.5 46.5 5.30623 46.5 10V38C46.5 42.6938 42.6954 46.5 38 46.5H10C5.30643 46.5 1.5 42.6936 1.5 38V10C1.5 5.30643 5.30643 1.5 10 1.5Z","stroke":"white","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M20 18.666L30.666 23.99L20 29.334V18.666ZM40 24C39.96 15.754 39.354 12.6 34.154 12.246C29.348 11.918 18.646 11.92 13.848 12.246C8.652 12.6 8.04 15.74 8 24C8.04 32.246 8.646 35.4 13.846 35.754C18.644 36.08 29.346 36.082 34.152 35.754C39.348 35.4 39.96 32.26 40 24Z","fill":"white","key":1})]);
}

YoutubeIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = YoutubeIcon;

YoutubeIcon.default = YoutubeIcon;
